module.exports = __webpack_public_path__ + "img/lareinadigital.d446e002.png";